<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Jack Compton’s Luck</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="frontMatterPage" id="fm01"><a id="page01"><div class="chapterHead"><h2 class="chapterTitle1"><span class="bold"><span>“Admiring the Chancellor heiress, are we?”</span></span></h2></div><div class="chapterBody"><p class="paraNoIndent1"><span>“Chancellor heiress?” Jack turned to look at his companion just as the dance ended and the young woman moved off the floor.</span></p><p class="paraNoIndent1"><span>“She’s a half sister of the present Chancellor head of the family, who is a financial wizard in the city. The heiress was sent to the States shortly after the war started, when she was quite a young girl. Came back earlier this year. Everyone and his brother’s after her.”</span></p><p class="paraNoIndent1"><span>He looked sideways at Jack. “How about it? Why not have a go yourself? God knows you could do with the money, no longer land-rich, and dirt-poor into the bargain. But however carefree she looks on the dance floor, she’s as hard as nails when it comes to suitors.”</span></p><p class="paraNoIndent1"><span>“And as hard as nails on the dance floor, too, if the performance I’ve just witnessed is any guide,” said Jack, determined not to reveal how much the mere sight of the Chancellor heiress had roused him.</span></p><p class="lineSpace1"><span> </span></p><p class="paraCenter"><span><span class="bold"><span><em class="italic"><span>Jack Compton’s Luck</span></em></span></span></span></p><p class="paraCenter"><span><span class="bold"><span>Harlequin</span></span><sup>®</sup><span class="bold"><span>Historical</span></span></span></p></div></a></div>
<a id="page01">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// jackcomptonsluck_fm01.vue?1ef76e63